export const HEALTH_DATA_UPDATED_EVENT = "qureo:health-data-updated";

export const emitHealthDataUpdated = (source = "unknown") => {
  if (typeof window === "undefined") return;

  window.dispatchEvent(
    new CustomEvent(HEALTH_DATA_UPDATED_EVENT, {
      detail: {
        source,
        at: Date.now(),
      },
    })
  );
};

export const onHealthDataUpdated = (handler, options = {}) => {
  if (typeof window === "undefined" || typeof handler !== "function") {
    return () => {};
  }

  const debounceMs = Number(options?.debounceMs) || 0;
  let timer = null;

  const runHandler = (detail) => {
    if (!debounceMs) {
      handler(detail);
      return;
    }

    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(() => {
      timer = null;
      handler(detail);
    }, debounceMs);
  };

  const listener = (event) => runHandler(event?.detail || {});
  window.addEventListener(HEALTH_DATA_UPDATED_EVENT, listener);
  return () => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    window.removeEventListener(HEALTH_DATA_UPDATED_EVENT, listener);
  };
};
